import {useBulkAddNotifications} from '../../../state-providers/bulk-add-notifications/bulk-add-notifications-state-provider'
import {PLACEHOLDER_ROW_COUNT, PlaceholderRow} from './roadmap-pagination'

/**
 * Renders skeleton rows during bulk add operations when there are no items in the roadmap view.
 * Only visible when a bulk add is in progress and the items list is empty.
 */
export function BulkAddRoadmapSkeleton() {
  const {shouldShowSkeleton} = useBulkAddNotifications()

  if (!shouldShowSkeleton) {
    return null
  }

  return (
    <>
      {[...Array(PLACEHOLDER_ROW_COUNT).keys()].map(key => (
        <PlaceholderRow key={key} />
      ))}
    </>
  )
}
